package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.common.usecases.RemoveTeamimAndMakafUseCase
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.screens.openQuestions.getOtiotIfIsNumeric
import com.eladfinish.bible.contest.screens.openQuestions.model.QuestionItem
import com.eladfinish.bible.contest.screens.openQuestions.model.QuestionItemJson
import com.eladfinish.bible.contest.utils.convertWordsToNumber

/**
 * Converts raw [QuestionItemJson] rows from the "Numbers by Books" special topic sheet
 * into [QuestionItem] instances.
 *
 * Each row contains a Hebrew question that embeds bold `<b>…</b>` words; those words
 * are extracted, cleaned of teamim/makaf, and converted to the numeric answer via
 * [convertWordsToNumber].  Mirrors the legacy `fillQuestionItemWithNumbersByBooks`.
 */
class BuildNumbersByBooksQuestionsUseCase(
    private val removeTeamimAndMakafUseCase: RemoveTeamimAndMakafUseCase,
) {

    operator fun invoke(items: List<QuestionItemJson>): List<QuestionItem> {
        var questionNum = 0
        return items.mapNotNull { item ->
            buildQuestion(item)?.also { questionNum++ }?.copy(num = questionNum)
        }
    }

    private fun buildQuestion(item: QuestionItemJson): QuestionItem? {
        val question = item.question.orEmpty()
        val chapter = item.chapter.orEmpty().getOtiotIfIsNumeric()
        val verse = item.verse.orEmpty().getOtiotIfIsNumeric()

        // Extract words that appear inside <b>…</b> tags
        val boldRegex = "<b>(.*?)</b>".toRegex()
        val numberWords = StringBuilder()
        boldRegex.findAll(question).forEach { match ->
            val word = removeTeamimAndMakafUseCase(match.groupValues[1])
            numberWords.append(word).append(" ")
        }
        if (numberWords.isEmpty()) return null
        numberWords.deleteAt(numberWords.length - 1)

        val answer = convertWordsToNumber(numberWords.toString())

        return QuestionItem(
            question = question + StringConstants.COLON_SPLITTER,
            answer = answer,
            author = "",
            book = item.book.orEmpty(),
            chapter = chapter,
            verse = verse,
            isAnswerVisible = true, // answers are always shown in this topic
        )
    }
}
